import {useMutation, useQuery} from '@tanstack/react-query';

import {
  RQ_FOLLOWUP_ADD_API,
  RQ_FOLLOWUP_COMPLETE_API,
  RQ_FOLLOWUP_DELETE_API,
  RQ_FOLLOWUP_LOOKUP_ALL_API,
  RQ_FOLLOWUP_LOOKUP_ID_API,
  RQ_FOLLOWUP_LOOKUP_PATIENT_API,
  RQ_FOLLOWUP_SCHEDULE_DATE_API,
  RQ_FOLLOWUP_TODAY_API,
} from './Constants';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url.replace(`<%= ${key} %>`, value),
});

//
// Add FollowUp
//
export const RQFollowUpAddAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_add_followup'],
    mutationFn: async ({formData, token}) => {
      return rqCreateRequest(
        RQ_FOLLOWUP_ADD_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });

//
// Complete FollowUp
//
export const RQFollowUpCompleteAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_complete_followup'],
    mutationFn: async ({id, formData, token}) => {
      return rqCreateRequest(
        withUrl(RQ_FOLLOWUP_COMPLETE_API, 'id', id),
        formData,
        token,
        null,
      );
    },
    ...options,
  });

//
// Lookup All FollowUps
//
export const RQFollowUpLookupAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_followups'],
    queryFn: () =>
      rqCreateRequest(
        RQ_FOLLOWUP_LOOKUP_ALL_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

//
// Lookup FollowUp By Id
//
export const RQFollowUpLookupByIdAPI = (
  id,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_followup', id],
    queryFn: () =>
      rqCreateRequest(
        withUrl(RQ_FOLLOWUP_LOOKUP_ID_API, 'id', id),
        null,
        token,
        null,
      ),
    enabled: !!id && !!token,
    ...options,
  });

// Lookup FollowUps By Patient
export const RQFollowUpLookupByPatientAPI = (
  patientId,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_followup_patient', patientId],
    queryFn: () =>
      rqCreateRequest(
        withUrl(
          RQ_FOLLOWUP_LOOKUP_PATIENT_API,
          'patientId',
          patientId,
        ),
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!patientId && !!token,
    ...options,
  });

//
// Today's FollowUps
//
export const RQFollowUpTodayAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_followup_today'],
    queryFn: () =>
      rqCreateRequest(
        RQ_FOLLOWUP_TODAY_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

//
// FollowUps By Schedule Date
//
export const RQFollowUpScheduleDateAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_followup_schedule_date'],
    queryFn: () =>
      rqCreateRequest(
        RQ_FOLLOWUP_SCHEDULE_DATE_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

//
// Delete FollowUp
//
export const RQDeleteFollowUpAPI = (callbacks = {}) =>
  useMutation({
    mutationKey: ['rq_delete_followup'],
    mutationFn: ({id, token}) =>
      rqCreateRequest(
        withUrl(RQ_FOLLOWUP_DELETE_API, 'id', id),
        null,
        token,
        null,
      ),
    ...callbacks,
  });
